export const getGisPdfTemplates = (gis_pdf_templates, formName) => {
  const gis_pdf_template = gis_pdf_templates.find((template) => template.terrago_template === formName)
  return gis_pdf_template || null
}

